/* eslint-disable */
const prebidConf = {
  timeout: 900,
  floorPrices: {
    floor: 0.01,
    monday: 0.01,
    tuesday: 0.01,
    wednesday: 0.01,
    thursday: 0.01,
    friday: 0.01,
    saturday: 0.01,
    sunday: 0.01,
  },
  analytics: {
    rubicon: 12736,
  },
  useSecondaryAdSizeForPrebid: false,
  priceBuckets: {
    buckets: [
      {
        precision: 2,
        min: 0,
        max: 5,
        increment: 0.05,
      },
      {
        precision: 2,
        min: 5,
        max: 10,
        increment: 0.1,
      },
      {
        precision: 2,
        min: 10,
        max: 20,
        increment: 0.25,
      },
      {
        precision: 2,
        min: 20,
        max: 100,
        increment: 1.0,
      },
    ],
  },
  desktop_bidParams: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "50970",
        zoneId: "612400",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
    {
      bidder: "sharethrough",
      params: {
        pkey: "FZs4prvu3TtPvmUcQNyYoFKQ"
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514105",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
    {
      bidder: 'onemobile',
      params: {
        dcn: '8a969499017574ff1c1d044b6594004e',
        pos: 'fast_company_desktop_tablet_prebid_hb_300x250',
        ext: {}
      }
    }
  ],
  desktop_bidParams300x250: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "50970",
        zoneId: "612400",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
   {
      bidder: "sharethrough",
      params: {
        pkey: "FZs4prvu3TtPvmUcQNyYoFKQ"
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514105",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
    {
      bidder: 'onemobile',
      params: {
        dcn: '8a969499017574ff1c1d044b6594004e',
        pos: 'fast_company_desktop_tablet_prebid_hb_300x250',
        ext: {}
      }
    }
  ],
  bidParams_300x600: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "50970",
        zoneId: "612400",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
   {
      bidder: "sharethrough",
      params: {
        pkey: "a6xGBNKAevZ1frsVrJ1gUvgT"
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514106",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
    {
      bidder: 'onemobile',
      params: {
        dcn: '8a969499017574ff1c1d044b6594004e',
        pos: 'fast_company_desktop_tablet_prebid_hb_300x600',
        ext: {}
      }
    }
  ],
  bidParams_970x250: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "50970",
        zoneId: "612400",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
   {
      bidder: "sharethrough",
      params: {
        pkey: "Hcaebuh1esJiQkybtawcfuqs"
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514108",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
    {
      bidder: 'onemobile',
      params: {
        dcn: '8a969499017574ff1c1d044b6594004e',
        pos: 'fast_company_desktop_tablet_prebid_hb_970x90',
        ext: {}
      }
    }
  ],
  bidParams_970x90: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "50970",
        zoneId: "612400",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
   {
      bidder: "sharethrough",
      params: {
        pkey: "YjPMgLauzyuiadC1Avj32gkQ"
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514107",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
    {
      bidder: 'onemobile',
      params: {
        dcn: '8a969499017574ff1c1d044b6594004e',
        pos: 'fast_company_desktop_tablet_prebid_hb_970x90',
        ext: {}
      }
    }
  ],
  bidParams_728x90: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "50970",
        zoneId: "612400",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087283",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910929",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66065",
      },
    },
   {
      bidder: "sharethrough",
      params: {
        pkey: "YjPMgLauzyuiadC1Avj32gkQ"
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514107",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
    {
      bidder: 'onemobile',
      params: {
        dcn: '8a969499017574ff1c1d044b6594004e',
        pos: 'fast_company_desktop_tablet_prebid_hb_728x90',
        ext: {}
      }
    }
  ],
  mobile_bidParams300x250: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "87584",
        zoneId: "612410",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087280",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910941",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66063",
      },
    },
   {
      bidder: "sharethrough",
      params: {
        pkey: "FZs4prvu3TtPvmUcQNyYoFKQ"
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514117",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
    {
      bidder: 'onemobile',
      params: {
        dcn: '8a969499017574ff1c1d044e47770052',
        pos: 'fast_company_mobile_prebid_hb_300x250',
        ext: {}
      }
    }
  ],
  mobile_bidParams320x50: [
    {
      bidder: "rubicon",
      params: {
        accountId: "12736",
        siteId: "87584",
        zoneId: "612410",
      },
    },
    {
      bidder: "appnexus",
      params: {
        placementId: "11087280",
      },
    },
    {
      bidder: "pangaea",
      params: {
        placementId: "12209196",
      },
    },
    {
      bidder: "openx",
      params: {
        unit: "538910941",
        delDomain: "mansueto-d.openx.net",
      },
    },
    {
      bidder: "emx_digital",
      params: {
        tagid: "66063",
      },
    },
    {
      bidder: "sharethrough",
      params: {
        pkey: "z43p5kuB99J3x94sQUhCabow"
      },
    },
    {
      bidder: "aol",
      params: {
        placement: "4514119",
        network: "9481.1",
      },
    },
    {
      bidder: "nobid",
      params: {
        siteId: "21988886671",
      },
    },
    {
      bidder: 'onemobile',
      params: {
        dcn: '8a969499017574ff1c1d044e47770052',
        pos: 'fast_company_mobile_prebid_hb_300x50',
        ext: {}
      }
    }
  ],
  oopBidParams: [
    {
      bidder: "unruly",
      params: {
        targetingUUID: "6f15e139-5f18-49a1-b52f-87e5e69ee65e",
        siteId: 1081534,
      },
    },
  ],
};

export default prebidConf;
